var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"bg-light",attrs:{"hover":"","loading":_vm.loading},on:{"click":_vm.navigateToComponent}},[_c('v-card-text',[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('h6',{staticClass:"text-info"},[_vm._v(_vm._s(_vm.data))]),_c('p',[_vm._v(_vm._s(_vm.description))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }